import { useCallback, useEffect, useRef } from 'react';
import { useRefCallback } from './useRefCallback';
/**
 * Возвращает функцию, которая вызовет переданный колбэк,
 * только если прошло `waitMs` миллисекунд с момента последнего вызова.
 * Хук гарантирует, что колбэк не будет вызван после анмаунта компонента.
 *
 * @param callback Колбэк
 * @param waitMs Время ожидания вызова колбэка
 * @typeParam Callback Тип колбэка
 * @returns Функция, вызывающая колбэк только спустя `waitMs` миллисекунд
 *          с момента последнего вызова полученной функции
 */
export function useDebounce(callback, waitMs) {
    const timer = useRef();
    useEffect(() => {
        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, []);
    // Навсегда стабилизируем ссылку на коллбэк
    const refCallback = useRefCallback(callback);
    return useCallback((...args) => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
            refCallback(...args);
        }, waitMs);
    }, [refCallback, waitMs]);
}
